import {TableContainer, TableHead, TableBody, TableCell, TableRow, Paper, Table, Grid, CircularProgress, Button, IconButton} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import {useTranslation} from "react-i18next";
import {observer} from 'mobx-react';
import {TAB_MISSING, TAB_DATE_MISSING} from './StatsCommon.js';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {getShortSpecName} from '../Trans.js';
import {getMidnightEpoch} from '../Util.js';
import StatsFilter from './StatsFilter.js';
import {COMM_OK} from '../WsR2.js';

const StatsDateMissing = observer(() => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');
	let pos = 0;

	function statsDateMissingGetSpecName(spec_id) {
		const spec = gStorage.lists.speclist.list.find((x) => x.id === spec_id);

		return getShortSpecName(spec, gStorage.conn.user);
	}

	function copyToClipboard() {
		let cpText = '';

		gStorage.stats.obsList.forEach((item, i) => {
			if (i < 50) {
				if (cpText.length)
					cpText += ', ';

				cpText += statsDateMissingGetSpecName(item.taxon);
			}
		});

		navigator.clipboard.writeText(cpText);
	}

	function statsDateMissingRxWs(status, msg) {
		if (status !== COMM_OK) {
			alert('statsDateMissingRxWs: error ' + status);
			return;
		} else if (msg.result !== 'OK') {
			alert('statsDateMissingRxWs: ' + msg.data.desc + '!');
			return;
		}

		if (gStorage.stats.tab !== TAB_MISSING || gStorage.stats.missing_tab !== TAB_DATE_MISSING)
			return;

		// console.log('statsDateMissingRxWs', msg);
		gStorage.stats.setObsList(msg.data.datemissing);
	}

	
	function loadDateMissing() {
		const midnight = getMidnightEpoch(gStorage.stats.dateMissingDate.toJSDate());
		const ts = new Date();
		ts.setTime(midnight * 1000);
		const month = ts.getMonth();
		const day = ts.getDate();
		
		// console.log('gStorage.gps.pos.accuracy', gStorage.gps.pos.accuracy);

		const msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'date',
			op: 'missing',
			data: {
				country: gStorage.stats.country.id,
				user: gStorage.conn.user.id,
				month: month + 1,
				day: day,
				lon: Math.floor(gStorage.gps.pos.longitude * 1000000),
				lat: Math.floor(gStorage.gps.pos.latitude * 1000000)
			}
		};

		// console.log('loadDateMissing', msg);
		// console.log('loadDateMissing', day, month + 1);
		
		gStorage.conn.ws.send(msg, statsDateMissingRxWs);
	}

	if (gStorage.stats.tab !== TAB_MISSING || gStorage.stats.missing_tab !== TAB_DATE_MISSING)
		return null;

	if (!gStorage.stats.obsList && gStorage.conn.online) {
		loadDateMissing();
		
		return (
			<Grid container direction="column" justifyContent="center" alignItems="center" spacing={0}>
				<CircularProgress sx={{mt: 10}} />
			</Grid>
		);
	}

	return (
		<Grid container direction="column" justifyContent="center" alignItems="center" spacing={0}>
			<Grid size={{xs: 12}} align={'center'}>
				<StatsFilter 
					loc = {{country: {
							value: gStorage.stats.country,
							style: {width: 200}
						}
					}}
				/>
			</Grid>

			<Grid style={{width: 300, marginBottom: 10}} align={'center'}>
				<>
					<Button 
						variant="contained" 
						style={{marginRight: 4, height: 40}}
						disabled={!gStorage.stats.obsList}
						onClick={() => {
							gStorage.stats.setDateMissingDate(gStorage.stats.dateMissingDate.minus({'days': 1}));
							gStorage.stats.setObsList(null);
						}}
					>
						&lt;
					</Button>

					<DatePicker
						onChange={(val) => {gStorage.stats.setDateMissingDate(val); gStorage.stats.setObsList(null);}}
						value={gStorage.stats.dateMissingDate}
						yearsOrder='desc'
						slotProps={{
							textField: {
								size: 'small',
								sx: {
									backgroundColor: 'white',
									width: 160
								}
							}
						}}
					/>

					<Button 
						variant="contained" 
						style={{marginLeft: 4, height: 40}}
						disabled={!gStorage.stats.obsList}
						onClick={() => {
							gStorage.stats.setDateMissingDate(gStorage.stats.dateMissingDate.plus({'days': 1}));
							gStorage.stats.setObsList(null);
						}}
					>
						&gt;
					</Button>
				</>
			</Grid>
			
			{gStorage.stats.obsList && 
				<TableContainer component={Paper} elevation={0} style={{width: 300, margin: 2}}>
					<Table size='small'>
						<TableHead>
							<TableRow>
								<TableCell padding='none'>#</TableCell>
								<TableCell>{t('stats._species')}</TableCell>
								<TableCell>
									<IconButton edge="start" color="inherit" onClick={copyToClipboard} aria-label="close">
										<ContentCopyIcon />
									</IconButton>
								</TableCell>
								<TableCell align='right'>{t('stats.score')}</TableCell>
							</TableRow>
						</TableHead>
						
						<TableBody>
							{gStorage.stats.obsList.map((elem, ind) => {
								if (elem.score <= 1) 
									return null;

								pos += 1;

								return (
									<TableRow key={ind}>
										<TableCell padding='none'>{pos}</TableCell>
										<TableCell colSpan={2}>{statsDateMissingGetSpecName(elem.taxon)}</TableCell>
										<TableCell align='right'>{elem.score}</TableCell>
									</TableRow>
								);
							})}
						</TableBody>
					</Table>
				</TableContainer>
			}

		</Grid>
	)
});

export default StatsDateMissing;
